import { useMutation, useQueryClient } from 'react-query';

import { projectsApi } from 'src/Services/API';
import { ProjectDto } from 'src/Services/API/generated/api';
import { trackEvent } from 'src/Services/Matomo';

const useDeleteProject = (assetId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    (projectId: string) => projectsApi.projectsControllerRemove(projectId, assetId),
    {
      onMutate: (projectId: string) => {
        const previousProjects = queryClient.getQueryData<ProjectDto[]>(['projects', assetId]);

        if (previousProjects) {
          queryClient.setQueryData<ProjectDto[]>(['projects', assetId], old =>
            (old ?? []).filter(p => p.id !== projectId)
          );
        }

        queryClient.cancelQueries(['projects', assetId]);

        return { previousProjects };
      },
      onError: (_err, _projectId, context) => {
        if (context?.previousProjects) {
          queryClient.setQueryData(['projects', assetId], context.previousProjects);
        }
      },
      onSuccess: () => {
        trackEvent('Project', 'delete');
        queryClient.invalidateQueries(['projects', assetId]);
        queryClient.invalidateQueries(['fetch-events']);
      },
    }
  );
};

export default useDeleteProject;
